import React, { useState ,useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch,FaUserCheck} from "react-icons/fa";
import { useLocation , useNavigate } from "react-router-dom";

function PayementHistroy({token}) {

  const location = useLocation();

  const dealer = location.state?.dealer;
   const navigate = useNavigate();
 

 const [searchTerm, setSearchTerm] = useState('');
const[list,setList] = useState([]);
const [showForm, setShowForm] = useState(false);
const [showMachineModal, setShowMachineModal] = useState(false);
const [selectedMachine, setSelectedMachine] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
const [showViewModal, setShowViewModal] = useState(false);
const [selectedData, setSelectedData] = useState(null);
const [showPayModal, setShowPayModal] = useState(false);
const [selectedDriver, setSelectedDriver] = useState(null);
const [showRefundModal, setShowRefundModal] = useState(false);


const fetchPayHistory = async () => {
  try {
    const res = await axios.get(`https://api.krimotion.in/fetch-payment-history/${dealer.id}`,
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;
 
    setList(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchPayHistory();

  }, []);

   const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];


 const handleDriverPayment = async () => {
  try {
    const res = await axios.put(
      `https://api.krimotion.in/update-driver-payment/${selectedDriver.id}`,
      {
        d_pay_status: "Success",
  d_paid_on: new Date().toISOString().slice(0, 19).replace("T", " ")
      },
      {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    );

    setShowPayModal(false);
    setSelectedDriver(null);
     fetchPayHistory();

    toast.success("Payment marked as Success!");
  } catch (error) {
    console.error(error);
    toast.error("Failed to update payment");
  }
};  

const handleRefund = async () => {
  try {
    const res = await axios.put(
      `https://api.krimotion.in/update-refund/${selectedDriver.id}`,
      {
        d_pay_status: "Refund",
        d_paid_on: new Date().toISOString().slice(0, 19).replace("T", " "),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

  
    toast.success("Refund completed successfully.");

    setShowRefundModal(false);
    setSelectedDriver(null);
    fetchPayHistory();
  } catch (err) {
    console.error(err);
    toast.error("Failed to process refund.");
  }
};

  return (
<>
 <div className="container py-4">
  
        <div className="border-0 mb-3 px-2 py-2">
  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

   
    <div className="d-flex align-items-center gap-3">

      <button
        className="btn btn-outline-secondary btn-sm rounded-pill px-3 mt-1"
        onClick={() => navigate(-1)}
      >
        <i className="bi bi-arrow-left me-2"></i>
        Back
      </button>

      <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
        Payment History
      </h4>

    </div>

    {/* Search */}
    <div style={{ flex: 1, maxWidth: "250px" }}>
      <div
        className="d-flex align-items-center rounded-pill overflow-hidden"
        style={{
          border: "1px solid var(--green)",
          height: "34px",
          paddingLeft: "8px",
          paddingRight: "8px",
          backgroundColor: "white",
        }}
      >
        <FaSearch
          style={{
            color: "var(--green)",
            fontSize: "14px",
          }}
        />

        <input
          type="text"
          className="form-control border-0 shadow-none"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            fontSize: "14px",
            height: "32px",
            marginLeft: "6px",
          }}
        />
      </div>
    </div>

  </div>
</div>


              {!showForm && (
                         <>
                         
                       
                
                     <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9'}}>
                 
                       <div className="card-body p-3">
                                <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0 text-center">
                        <thead  >
                          <tr>
                          
                            <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Machine Name</th>
                            <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Cusotmer Name</th>
                            <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Driver Name</th>
                       
                              <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Amount </th> 
                            <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Pay Mode </th>    
                                                    
                          <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Pay Status </th>
                            <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Added On</th>
                             <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Action</th>
                          </tr>
                        </thead>
                
                        <tbody>
                          {filteredData.length > 0 ? (
                            filteredData.map((dealer, index) => (
                              <tr key={index}>
                                <td>{dealer.machine_name}</td>
                                <td>{dealer.cust_name}</td>
                                <td>{dealer.d_name}</td>
                                   <td>{dealer.amount}</td>
                              <td>{dealer.pay_mode} </td>
                             <td>{dealer.pay_status} </td>
                              <td>{dealer.added_on} </td>
                              <td>
                                 <div className="d-flex justify-content-center align-items-center gap-2">
<button
  className="btn-action btn-primary-custom"
  onClick={() => {
    setSelectedData(dealer);
    setShowViewModal(true);
  }}
>
  <i className="bi bi-eye me-1"></i>
  View
</button>

{dealer.enquire_status === "Refund_Request" ? (

  <button
    className={`btn-action ${
      dealer.d_pay_status === "Refund"
        ? "btn-success-custom"
        : "btn-warning-custom"
    }`}
    onClick={() => {
        setSelectedDriver(dealer);
    setShowRefundModal(true);
    }}
      disabled={ dealer.d_pay_status === "Refund" }
  >
    {dealer.d_pay_status === "Refund" ? (
      <>
        <i className="bi bi-check-circle me-1"></i>
       Refunded
      </>
    ) : (
      <>
        <i className="bi bi-arrow-counterclockwise me-1"></i>
        Refund
      </>
    )}
  </button>

) : (

  <button
    className={`btn-action ${
      dealer.d_pay_status === "Success"
        ? "btn-success-custom"
        : "btn-warning-custom"
    }`}
    onClick={() => {
      setSelectedDriver(dealer);
      setShowPayModal(true);
    }}
      disabled={
    dealer.d_pay_status === "Success" 
  }
  >
    {dealer.d_pay_status === "Pending" ? (
      <>
        <i className="bi bi-check-circle me-1"></i>
        Pay
      </>
    ) : (
      <>
        <i className="bi bi-check-circle-fill me-1"></i>
        Paid
      </>
    )}
  </button>

)}

  </div>
                                 </td>
                        
                      </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center py-4">
                                No List Found
                              </td>
                            </tr>
                          )}
                        </tbody>
            
                      </table>
                    </div>
                       </div> 
                
    
               
{showViewModal && (
  <div
    className="modal d-block"
    style={{
      background: "rgba(15, 23, 42, 0.6)",
      backdropFilter: "blur(6px)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

      <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">

        {/* HEADER */}
        <div className="modal-header bg-dark text-white py-3">
          <div>
            <h5 className="mb-0 fw-bold">Booking Details</h5>
            <small className="text-white-50">
              ID: #{selectedData?.id || "N/A"}
            </small>
          </div>

          <button
            className="btn-close btn-close-white"
            onClick={() => {
              setShowViewModal(false);
              setSelectedData(null);
            }}
          />
        </div>

        {/* BODY */}
        <div className="modal-body p-2 bg-light">

          {/* MACHINE CARD */}
          <div className="card border-0 shadow-sm mb-3 rounded-3">
            <div className="card-body">

              <h6 className="fw-bold text-primary mb-3">
                🚜 Machine Details
              </h6>

              <div className="row g-2">
                <div className="col-md-6">
                  <small className="text-muted">Machine Name</small>
                  <div className="fw-semibold">{selectedData?.machine_name}</div>
                </div>

                <div className="col-md-6">
                  <small className="text-muted">Added On</small>
                  <div className="fw-semibold">{selectedData?.added_on}</div>
                </div>
              </div>

            </div>
          </div>

          {/* CUSTOMER CARD */}
          <div className="card border-0 shadow-sm mb-3 rounded-3">
            <div className="card-body">

              <h6 className="fw-bold text-success mb-3">
                👤 Customer Details
              </h6>

              <div className="row">
                <div className="col-md-6">
                  <small className="text-muted">Customer Name</small>
                  <div className="fw-semibold">{selectedData?.cust_name}</div>
                </div>

                <div className="col-md-6">
                  <small className="text-muted">Customer Mobile</small>
                  <div className="fw-semibold">{selectedData?.cust_mobile}</div>
                </div>
              </div>

            </div>
          </div>

          {/* DRIVER CARD */}
          <div className="card border-0 shadow-sm mb-3 rounded-3">
            <div className="card-body">

              <h6 className="fw-bold text-warning mb-3">
                🚗 Driver Details
              </h6>

              <div className="row">
                <div className="col-md-6">
                  <small className="text-muted">Driver Name</small>
                  <div className="fw-semibold">{selectedData?.d_name}</div>
                </div>

                <div className="col-md-6">
                  <small className="text-muted">Driver Mobile</small>
                  <div className="fw-semibold">{selectedData?.mobile}</div>
                </div>
              </div>

            </div>
          </div>

          {/* PAYMENT CARD */}
          <div className="card border-0 shadow-sm mb-3 rounded-3">
            <div className="card-body">

              <h6 className="fw-bold text-primary mb-3">
                💰 Payment Details
              </h6>

              <div className="row g-2">

                <div className="col-md-6">
                  <small className="text-muted">Payment Mode</small>
                  <div className="fw-semibold">
                    {selectedData?.pay_mode}
                  </div>
                </div>

         <div className="col-md-6 d-flex flex-column">
  <small className="text-muted mb-1">Payment Status</small>

  <span
    className={`badge px-3 py-2 w-fit ${
      selectedData?.pay_status === "Success"
        ? "bg-success"
        : "bg-warning text-dark"
    }`}
    style={{ width: "fit-content" }}
  >
    {selectedData?.pay_status}
  </span>
</div>

              </div>

            </div>
          </div>

          {/* Driver payment detail */}
            <div className="card border-0 shadow-sm rounded-3">
            <div className="card-body">

              <h6 className="fw-bold text-danger mb-3">
                💰Driver Payment Details
              </h6>

              <div className="row g-2">


         <div className="col-md-6 d-flex flex-column">
  <small className="text-muted mb-1">Payment Status</small>

  <span
    className={`badge px-3 py-2 w-fit ${
      selectedData?.d_pay_status === "Success"
        ? "bg-success"
        : "bg-warning text-dark"
    }`}
    style={{ width: "fit-content" }}
  >
    {selectedData?.d_pay_status}
  </span>
</div>


                <div className="col-md-6">
                  <small className="text-muted">Payment date</small>
                  <div className="fw-semibold">
                    {selectedData?.d_paid_on}
                  </div>
                </div>
                <hr/>

                {selectedData?.enquire_status == 'Refund_Request' && (
<>
    <div className="col-md-6">
                  <small className="text-dark">Rejected By</small>
                  <div className="fw-semibold">
                    {selectedData?.rejected_by}
                  </div>
                </div>

                    <div className="col-md-6">
                  <small className="text-dark">Reject date</small>
                  <div className="fw-semibold">
                    {selectedData?.rejected_on}
                  </div>
                </div>
                    <div className="col-md-6">
                  <small className="text-dark">Remark</small>
                  <div className="fw-semibold">
                    {selectedData?.rej_remark}
                  </div>
                </div>
</>

                )}

              </div>

            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer bg-white border-0">
          <button
            className="btn btn-outline-secondary px-2"
            onClick={() => {
              setShowViewModal(false);
              setSelectedData(null);
            }}
          >
            Close
          </button>
        </div>

      </div>

    </div>
  </div>
)}

{showPayModal && (
  <div
    className="modal d-block"
    style={{
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(4px)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered">

      <div
        className="modal-content border-0 shadow-lg"
        style={{ borderRadius: "18px", overflow: "hidden" }}
      >

        {/* HEADER */}
        <div
          className="text-center py-4"
          style={{
            background: "linear-gradient(135deg,#f59e0b,#f97316)",
          }}
        >

          <div
            className="mx-auto d-flex align-items-center justify-content-center"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
            }}
          >
           <FaUserCheck size={34} color="#fff" />
          </div>

          <h4 className="text-white fw-bold mt-3 mb-0">
            Confirm Driver Payment
          </h4>

        </div>

        {/* BODY */}
        <div className="p-4 text-center">

          <h5 className="fw-bold mb-2">
            {selectedDriver?.d_name}
          </h5>

          <p className="text-muted mb-4">
            Are you sure you want to mark this payment as{" "}
            <strong>SUCCESS</strong>?
          </p>

          {/* STATUS BOX */}
          <div
            className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
            style={{
              background: "#fef3c7",
            }}
          >
            <span className="me-2 fw-semibold text-dark">
              Current Status
            </span>

            <span className="badge bg-warning text-dark">
              {selectedDriver?.d_pay_status || "Pending"}
            </span>
          </div>

        </div>

        {/* FOOTER */}
        <div className="px-4 pb-4 d-flex gap-3">

          <button
            className="btn btn-light border w-50"
            style={{ borderRadius: "10px" }}
            onClick={() => setShowPayModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success w-50"
            style={{
              borderRadius: "10px",
              fontWeight: 600,
            }}
            onClick={handleDriverPayment}
          >
            <i className="bi bi-check-circle me-1"></i>
            Confirm Payment
          </button>

        </div>

      </div>
    </div>
  </div>
)}


{showRefundModal && (
  <div
    className="modal d-block"
    style={{
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(4px)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered">

      <div
        className="modal-content border-0 shadow-lg"
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >

        {/* Header */}
        <div
          className="text-center py-4"
          style={{
            background:
              "linear-gradient(135deg,#dc3545,#ef4444)",
          }}
        >
          <div
            className="mx-auto d-flex align-items-center justify-content-center"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "rgba(255,255,255,.2)",
            }}
          >
             <FaUserCheck size={34} color="#fff" />
          </div>

          <h4 className="text-white fw-bold mt-3 mb-0">
            Confirm Refund
          </h4>
        </div>

        {/* Body */}
        <div className="p-4 text-center">

          <h5 className="fw-bold">
            {selectedDriver?.cust_name}
          </h5>

          <p className="text-muted">
            Are you sure you want to refund this booking?
          </p>

          <div
            className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
            style={{
              background: "#fee2e2",
            }}
          >
            <span className="fw-semibold me-2">
              Current Status
            </span>

            <span className="badge bg-warning text-dark">
              {selectedDriver?.enquire_status}
            </span>
          </div>

          {/* <div className="mt-4">

            <div className="row text-start">

              <div className="col-6 mb-3">
                <small className="text-muted d-block">
                  Machine
                </small>
                <strong>{selectedDriver?.machine_name}</strong>
              </div>

              <div className="col-6 mb-3">
                <small className="text-muted d-block">
                  Driver
                </small>
                <strong>{selectedDriver?.d_name}</strong>
              </div>

              <div className="col-6">
                <small className="text-muted d-block">
                  Payment Status
                </small>
                <span className="badge bg-success">
                  {selectedDriver?.d_pay_status}
                </span>
              </div>

              <div className="col-6">
                <small className="text-muted d-block">
                  Payment Mode
                </small>
                <strong>{selectedDriver?.pay_mode}</strong>
              </div>

            </div>

          </div> */}

        </div>

        {/* Footer */}
        <div className="px-4 pb-4 d-flex gap-3">

          <button
            className="btn btn-light border w-50"
            style={{
              borderRadius: "10px",
            }}
            onClick={() => setShowRefundModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger w-50"
            style={{
              borderRadius: "10px",
              fontWeight: "600",
            }}
            onClick={handleRefund}
          >
            <i className="bi bi-arrow-counterclockwise me-2"></i>
            Confirm Refund
          </button>

        </div>

      </div>

    </div>
  </div>
)}
          
                  </div>
                
                    </>
                         )}
    </div>

</>
  )
}

export default PayementHistroy
